import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getAccountScopeUserSettings } from "owa-session-store";

// Prime setting id for OCS `mail_classic_indented_view`.
// Keep in sync with `primeSettingActionToNameMap` in owa-offline-prime-settings.
const CLASSIC_INDENTED_VIEW_PRIME_SETTING_ID = "Mail_Classic_Indented_View";

// Reads the classic indented view value from prime settings.
// Returns null when it is not primed or not a boolean; callers should fall back to OCS.
export default function getClassicIndentedViewPrimeSetting(): boolean | null {
    const primeSettings = getAccountScopeUserSettings(getGlobalSettingsAccountMailboxInfo())?.PrimeSettings;
    const value = primeSettings?.Items?.filter(item => item.Id === CLASSIC_INDENTED_VIEW_PRIME_SETTING_ID).map(item => item.Value?.[0]?.value)[0];
    
    if (value == null) {
        return null;
    }
    
    try {
        const parsedValue = JSON.parse(value);
        return typeof parsedValue === "boolean" ? parsedValue : null;
    }
    catch {
        return null;
    }
}
